export default "__VITE_ASSET__BAHCKq65__"